const LoadingAreaLegs = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();

        console.log("check_here")
        if (props.onClickHandler) {
            props.onClickHandler(props);
        }    };

    return (
        <div className="map-icon-component">
            <button onClick={handleRouteClick} className="custom-btn label label-info" title="View Invoices">
                {/* <i style={{ color: "#1E73D5" }} className="icofont icofont-site-map f25"></i> */}
                <i className="icofont icofont-site-map f18"></i> 
            </button>
        </div>
    );
};

export default LoadingAreaLegs;